import { InputGroup, Intent, Switch } from '@blueprintjs/core';
import React from 'react';
import { PERMISSIONS } from '@moleculeone/auth';

import Protected from '@f/components/shared/protected/Protected';
import {
  ErrorCallout,
  ParamContainer,
  ParamGroup,
} from '@f/components/shared/search-parameter-form/SearchParameterForm';

import { PresetEditable } from '../Preset';

function getValueFromEvent(event: React.ChangeEvent<HTMLInputElement>) {
  if (!event.target) {
    return event;
  }
  switch (event.target.type) {
    case 'checkbox':
      return event.target.checked;
    default:
      return event.target.value;
  }
}

interface PresetMetaFormProps {
  className?: string;
  preset: PresetEditable;
  isNameDuplicate: boolean;
  onChange: (preset: PresetEditable) => void;
}

export function PresetMetaForm(props: PresetMetaFormProps) {
  const { className, onChange, preset, isNameDuplicate } = props;
  const { name, isApiDefault } = preset;

  const changeParameter = (name: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = getValueFromEvent(event);

    if (preset[name] === value) {
      return;
    }

    const updatedPreset = {
      ...preset,
      [name]: value,
    };

    onChange(updatedPreset);
  };

  return (
    <ParamGroup className={className}>
      <ParamContainer helperText="Unique name between 3 and 100 characters long, containing only lowercase letters, numbers, spaces, dots (.), hyphens (-) and underscores (_).">
        <InputGroup
          large
          value={name}
          type="text"
          name="name"
          intent={Intent.NONE}
          placeholder="Enter preset name..."
          pattern="^[a-z\d\-\._ ]{3,100}$"
          required
          onChange={changeParameter('name')}
        />
        {isNameDuplicate && <ErrorCallout intent={Intent.DANGER}>Preset name is not available.</ErrorCallout>}
      </ParamContainer>

      <ParamContainer helperText="Use as default parameters when starting scoring searches.">
        <Switch large checked={isApiDefault} label="Default search preset" onChange={changeParameter('isApiDefault')} />
      </ParamContainer>
    </ParamGroup>
  );
}
